export default {
  // 动态
  BizManag: '业务管理',
  Set: '品牌级业务设置',
  Brand: '总部管理',
  BrandIndex: '品牌概览',
  BrandManag: '品牌管理',
  DeptList: '员工与部门',
  RoleList: '角色管理',
  StoreManag: '门店管理',
  StoreList: '门店管理',
  StoreEmployeeList: '门店员工',
  ProductOperate: '商品运营',
  ShopProduct: '门店商品',
  BrandMaterial: '素材管理',
  StoreOperations: '门店业务',
  ProductManage: '商品管理',
  ProductArchive: '商品档案',
  ProductList: '商品列表',
  Classfication: '商品分类',
  ProductSynch: '商品同步',
  Attribute: '商品属性',
  StoreProduct: '门店商品列表',
  CommonCenter: '收银POS',
  PrintTemplateList: '小票模版',
  OrderManage: '订单管理',
  OrderList: '订单查询',
  OrderDetail: '订单详情',
  OrderPrint: '订单打印',
  // Profile: '个人中心',
  ShopProductSynch: '门店商品同步',
  Asset: '资产流水',
  AssetScope: '资产使用规则',
  MemberLevel: '会员等级管理',
  Operation: '会员操作日志',
  Profile: '会员档案 ',
  AccountCenterHome: '账号中心',
  AccountCenterPassword: '修改密码',
  Card: '会员卡管理',
  Tourist: '游客列表',
  MemberCenter: '会员中心',
  Membership: '会员管理CRM',
  Printer: '打印机管理',
  PrintRules: '打印规则',
  Printtemplate: '票据模版',
  HeadSettings: '打印管理 ',
  HeadManag: '总部管理',
  Equipment: '虚拟设备管理',
  Project: '扣费项目',
  Record: '项目扣费记录',
  ProjectDeduction: '设备运维',
  Deduction: '扣费管理',
  OrderDetails: '订单详情',
  DeviceManage: '设备管理',
  DeviceAuthorization: '设备授权',
  DeviceRecord: '设备记录',
  // 运维工具（后端菜单：设备运维/运维工具/设备授权）
  OperationTools: '运维工具',
  DeviceActivation: '设备授权',
  // 收银台管理（后端菜单：设备运维/设备管理/收银台管理）
  CashierDevice: '收银台管理',
  MemberConfig: '会员配置',
  MemberAsset: '会员资产',
  OperateRecord: '操作记录',
  LifeLog: '会员变更记录',
  Advert: '广告管理',
  AdvertEdit: '广告设置',
  Agreement: '协议管理',

  // 静态菜单
  AddRole: '角色设置',
  StoreDetail: '门店经营信息',
  MiniProgramManage: '管理小程序',
  DecorateAdd: '新增装修模板',
  AddFrontClass: '前台分类设置',
  AddProduct: '商品设置',
  SynchDrtails: '同步详情',
  RefundDetails: '售后详情',
  PrintTemplateBillEdit: '设置打印模版',
  ShopTemplateView: '门店打印模版',
  ProductStock: '商品库存管理',
  FeeCenterOrderConfirm: '确认订单',
  FeeCenterPayment: '订单支付',

  // 费用中心（后端菜单：费用中心/增值服务/订单管理，动态路由 name 为 path 首字母大写）
  FeeCenter: '费用中心',
  FeeCenterService: '增值服务',
  FeeCenterOrder: '订单管理',
  Service: '增值服务',
  Order: '订单管理',

  // 菜单提示
  topNavTip: '设置常用，最多可设置4个',
  Business: '业务运营',
  OnlineOperation: '线上运营',
  Decorate: '装修管理',
  Template: '模板库',
  ChannelManage: '渠道管理',
  // 类别
  SmartStore: '智界数店',
  AllPhenomena: '智界鸿图',
  DataAnalysis: '数据分析',
};
